import { isNumber } from 'angular';
import { StaticLocationParamaters } from 'cg-foundation-theming';
var RoutesHelper = (function () {
    function RoutesHelper($location, locationService, statusMessage) {
        this.$location = $location;
        this.locationService = locationService;
        this.statusMessage = statusMessage;
    }
    RoutesHelper.prototype.setGallery = function (thirdPartyProducts, errorCode) {
        if (thirdPartyProducts === void 0) { thirdPartyProducts = []; }
        if (errorCode === void 0) { errorCode = -1; }
        var filterQuery = this.locationService.get(StaticLocationParamaters.filters);
        var orderByQuery = this.locationService.get(StaticLocationParamaters.orderBy);
        var url = this.locationService.build('compatibilityguide/gallery', { thirdPartyProducts: thirdPartyProducts });
        if (filterQuery) {
            url += "&" + StaticLocationParamaters.filters + "=" + filterQuery;
        }
        if (orderByQuery) {
            url += "&" + StaticLocationParamaters.orderBy + "=" + orderByQuery;
        }
        this.setErrorCode(errorCode);
        this.$location.url(url);
    };
    RoutesHelper.prototype.setHome = function (errorCode) {
        if (errorCode === void 0) { errorCode = -1; }
        this.setErrorCode(errorCode);
        this.$location.url(this.locationService.build('compatibilityguide'));
    };
    RoutesHelper.prototype.setErrorCode = function (errorCode) {
        if (!isNumber(errorCode) || errorCode === -1) {
            return;
        }
        this.statusMessage.set(errorCode);
    };
    RoutesHelper.$inject = ['$location', 'locationService', 'statusMessage'];
    return RoutesHelper;
}());
export { RoutesHelper };
